import _ from 'underscore';
import RouteLayer from './types/RouteLayer';
import RouteModel from './types/models/RouteModel';
import RouteCollection from './types/models/RoutesCollection';
import RouteLabels from 'views/routeLabels/RouteLabels';

export default class HandleRoutes {
  /**
   * @class HandleRoutes
   * @classdesc Create and handle the routes on map
   * @param {Widget} widget - The widget where the routes will be loaded
   */
  constructor(widget, opt) {
    this.map = widget.map;
    this.routes = [];
    this.routesView = [];
    this.widget = widget;
    this.routeStyles = opt.routeStyles;
    this.backgroundRoute = opt.backgroundRoute;
    this.drawLabel = opt.drawLabel;
    this.fitBoundsToRoutes = opt.routeStyles && opt.routeStyles.fitBoundsToRoutes ? opt.routeStyles.fitBoundsToRoutes :
      true;
    this.routeClickable = !_.isUndefined(opt.routeClickable) ? opt.routeClickable : true;
    this.goBoundingInAlternativeRouteClick = !_.isUndefined(opt.goBoundingInAlternativeRouteClick) ?
      opt.goBoundingInAlternativeRouteClick : false;
    this.routeHoverable = !_.isUndefined(opt.routeHoverable) ? opt.routeHoverable : true;
    this.routesCollection = new RouteCollection();
    this.transitStops = opt.transitStops;
    if (this.drawLabel) {
      this.labelView = new RouteLabels({
        widget: this.widget,
        config: opt.drawLabel
      });
    }
  }

  updateRoutes(providedRoutes) {
    this.removeRoutes();
    this.createRoutes(providedRoutes);
    this.drawRoutes();
    this._bindEvents();
    if (this.drawLabel) {
      this._drawLabels();
    }
  }
  _drawLabels() {
    this.labelView.removeLabels();
    let selectedRoute = this.getSelectedRoute();
    this.labelView.createLabel(selectedRoute[0]);
  }
  _bindEvents() {
    //deselect other routes
    this.routesCollection.on('change:selected', (model) => {
      if (model.isSelected()) {
        this.routesCollection.selectModel(model);
        if (this.drawLabel) {
          this._drawLabels();
        }
      }
    });
  }
  createRoutes(providedRoutes) {
    let i = 0;
    let bounds = new google.maps.LatLngBounds();
    providedRoutes.forEach((providedRoute, index) => {
      let routeModel;
      routeModel = new RouteModel({ 'selected': index === 0 }); //REVISAR ESTO
      this.routesCollection.add(routeModel);
      let routeView = new RouteLayer(providedRoute, {
        widget: this.widget,
        routeStyles: this.routeStyles,
        transitStops: this.transitStops,
        model: routeModel,
        index: index,
        routeClickable: this.routeClickable,
        routeHoverable: this.routeHoverable,
        backgroundRoute: this.backgroundRoute
      });
      if (routeModel.getAgency() && routeModel.getAgency().length > 0) {
        routeView.setLimitToAgencies(i);
        i++;
      }
      routeView.routeModel.on('change:selected', (model) => {
        if (model.isSelected()) {
          this.widget.bus.trigger('SELECT_ROUTE', routeView.providedRoute);
          this.legendItems = [];
          this.addRouteToLegend(routeView);
          if (this.goBoundingInAlternativeRouteClick) {
            this.changeBoundsMap(bounds);
          }
        }
      }, routeView.routeModel);
      this.routesView.push(routeView);
      bounds.union(routeView.getBounds());
      this.changeBoundsMap(bounds);
    });
  }
  drawRoutes() {
    this.legendItems = [];
    _.each(this.routesView, (routeView) => {
      routeView.draw();
      this.addRouteToLegend(routeView);
    });
  }
  addRouteToLegend(routeView) {
    if (routeView.styles.legend && (routeView.routeModel.getStyle() === 'defaultStyle' || routeView.routeModel.isSelected())) {
      this.legendItems = this.legendItems.concat(routeView.getLegend());
      if (this.legendItems.length > 0) {
        this.widget.bus.trigger('UPDATE_LEGEND', this.legendItems);
      }
    }
  }
  removeRoutes() {
    if (this.labelView) {
      this.labelView.removeLabels();
    }
    _.each(this.routesView, (routeView) => {
      routeView.remove();
    });
    this.routesView = [];
  }

  changeBoundsMap(bounds) {
    if (this.fitBoundsToRoutes) {
      this.map.fitBounds(bounds);
    }
  }

  getSelectedRoute() {
    return this.routesView.filter(routeView => {
      return routeView.routeModel.isSelected();
    });
  }

  hideAlternativeRoutes() {
    let selectedRoute = this.getSelectedRoute();
    this.routesView.forEach((r, i) => {
      if (i !== selectedRoute[0].index) {
        r.hide();
      }
    });
  }

  showAlternativeRoutes() {
    this.routesView.forEach((r, i) => {
      r.show();
    });
  }
}



// WEBPACK FOOTER //
// ./lmm-widget/src/layers/HandleRoutes.js